import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.pad-start.js";
import { utcToZonedTime } from 'date-fns-tz';
/*
 * Converts a UTC datetime string into date and time strings in a target IANA timezone.
 */
export default function getDateAndTimeInTimezone(_ref) {
  var dateTime = _ref.dateTime,
    timezone = _ref.timezone;
  if (!dateTime) {
    return {
      date: '',
      time: ''
    };
  }
  try {
    var zonedDateTime = utcToZonedTime(dateTime, timezone);
    var year = zonedDateTime.getFullYear();
    var month = String(zonedDateTime.getMonth() + 1).padStart(2, '0');
    var day = String(zonedDateTime.getDate()).padStart(2, '0');
    var hours = String(zonedDateTime.getHours()).padStart(2, '0');
    var minutes = String(zonedDateTime.getMinutes()).padStart(2, '0');
    var seconds = String(zonedDateTime.getSeconds()).padStart(2, '0');
    return {
      date: "".concat(year, "-").concat(month, "-").concat(day),
      time: "".concat(hours, ":").concat(minutes, ":").concat(seconds)
    };
  } catch (_unused) {
    return {
      date: '',
      time: ''
    };
  }
}